import React, { useEffect } from 'react';
import PrivateRoute from '@shared/routing/PrivateRoute';
import { Switch, useLocation } from 'react-router';
import { HolidayCreateEditPage } from "./HolidayCreateEditPage";
import { HolidaySelectUserPage } from "./HolidaySelectUserPage";
import { HolidayCreatedSuccessfullyPage } from "./HolidayCreatedSuccessfullyPage";
import { UserAnnualHolidayView } from "./user-annual-holidays/UserAnnualHolidayView";
import { TeamsMonthlyHolidayView } from "./teams-monthly-holidays/TeamsMonthlyHolidayView";
import HolidayApprovalsView from "./approvals/HolidayApprovalsView";
import HolidayReportsView from "./holiday-reports-page/HolidayReportsView";
import { useDispatch, useSelector } from "react-redux";
import { loadLineReports } from '@shared/store/companyStructure.duck';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { WorkPlannerLayout } from '@shared/ui/molecules/work-planner/WorkPlannerLayout';
import { LeavePlannerNotEnabled } from "./components/LeavePlannerNotEnabled";
import { HolidayAllowanceSettings } from "./settings/HolidayAllowanceSettings";
import { isInTeams } from '@shared/utils/TeamsUtils';
import { app } from "@microsoft/teams-js";
import { HolidayCarryOverPreview } from "./carry-over/HolidayCarryOverPreview";
import { HolidayCarryOverExpiryPreview } from "./carry-over/HolidayCarryOverExpiryPreview";

export default function HolidaysRouting() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentUser = useSelector(selectCurrentUser);
  const isHolidayTrackingEnabled = currentUser?.companyEntity.enableHolidayBooking;

  useEffect(() => {
    if (isHolidayTrackingEnabled) {
      dispatch(loadLineReports());
    }
  }, [dispatch, isHolidayTrackingEnabled]);

  useEffect(() => {
    if (isInTeams()) {
      app.getContext().then((context: app.Context) => {
        if (context.page.subPageId) {
          console.log('holidayRouting', window.location.href)
          if (window.location.href.endsWith('/holidays')) {
            const parts = context.page.subPageId.split(':');
            if (parts.length >= 2 && parts[0] === 'leave' && !location.pathname.includes(parts[1])) {
              window.location.href = `/holidays/${parts[1]}`;
            }
          }
        }
      })
    }
  }, [location, dispatch]);

  if (!isHolidayTrackingEnabled) {
    return (
      <WorkPlannerLayout pageContentStyles={{paddingTop: 24}} numberOfWeeksInMonth={6}>
        <LeavePlannerNotEnabled />
      </WorkPlannerLayout>
    )
  }

  return (
    <Switch>
      <PrivateRoute exact path="/holidays/add" component={HolidaySelectUserPage}/>
      <PrivateRoute exact path="/holidays/:user/add" component={HolidayCreateEditPage}/>
      <PrivateRoute exact path="/holidays/:user/success/:from/:to" component={HolidayCreatedSuccessfullyPage}/>
      <PrivateRoute exact path="/holidays/:user/edit/:date" component={HolidayCreateEditPage}/>

      <PrivateRoute exact path="/holidays" component={TeamsMonthlyHolidayView}/>
      <PrivateRoute exact path="/holidays/add" component={HolidayCreateEditPage}/>
      <PrivateRoute exact path="/holidays/edit/:date/:user" component={HolidayCreateEditPage}/>

      <PrivateRoute exact path="/holidays/leave-planner" component={TeamsMonthlyHolidayView}/>
      <PrivateRoute exact path="/holidays/view-approvals" component={HolidayApprovalsView}/>
      <PrivateRoute exact path="/holidays/reports" component={HolidayReportsView}/>
      <PrivateRoute exact path="/holidays/me" component={UserAnnualHolidayView}/>
      <PrivateRoute exact path="/holidays/:userId" component={UserAnnualHolidayView}/>

      <PrivateRoute exact path="/holidays/settings/allowance" component={HolidayAllowanceSettings}/>
      <PrivateRoute exact path="/holidays/settings/allowance-carry-over-preview" component={HolidayCarryOverPreview}/>
      <PrivateRoute exact path="/holidays/settings/allowance-carry-over-expiry-days" component={HolidayCarryOverExpiryPreview}/>
    </Switch>
  )
}
